(function () {
  var campaignId = "end_of_season_training_collars_2026";

  function getCampaignContext() {
    var params = new URLSearchParams(window.location.search);
    var context = {
      campaign_id: campaignId,
      page_path: window.location.pathname,
    };

    ["ref", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(
      function (key) {
        var value = params.get(key);
        if (value) context[key] = value;
      }
    );

    return context;
  }

  function track(eventName, details) {
    var payload = Object.assign({}, getCampaignContext(), details || {});
    var envelope = Object.assign({ event: eventName }, payload);

    window.__eossAnalyticsQueue = window.__eossAnalyticsQueue || [];
    window.__eossAnalyticsQueue.push(envelope);
    document.dispatchEvent(new CustomEvent("gl:end_of_season_sale", { detail: envelope }));

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, payload);
      return;
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(envelope);
    }
  }

  function viewProductList(element) {
    if (element.dataset.eossViewed === "true") return;
    element.dataset.eossViewed = "true";
    track("view_item_list", {
      item_list_id: "end_of_season_training_collars_2026",
      item_list_name: "End of season training collar sale",
      items: [
        { item_id: "barkwise-complete", item_name: "BarkWise Complete" },
        { item_id: "happy-tails-training-collar", item_name: "Happy Tails Training Collar" },
      ],
    });
  }

  function initPromotionViews(root) {
    root.querySelectorAll("[data-eoss-promotion]:not([data-eoss-viewed])").forEach(function (element) {
      element.dataset.eossViewed = "true";
      track("view_promotion", {
        promotion_id: element.dataset.eossPromotionId || campaignId,
        promotion_name: element.dataset.eossPromotionName || "End of season training collar sale",
        creative_slot: element.dataset.eossPlacement || "unknown",
      });
    });

    root.querySelectorAll("[data-eoss-product-list]:not([data-eoss-observed])").forEach(function (element) {
      element.dataset.eossObserved = "true";

      if (!("IntersectionObserver" in window)) {
        viewProductList(element);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        viewProductList(element);
        observer.disconnect();
      }, {
        threshold: 0.15,
      });

      observer.observe(element);
    });
  }

  function clickDetails(element, eventName) {
    var location = element.dataset.eossLocation || "sale_page";
    var destination = element.getAttribute("href") || undefined;

    if (eventName === "select_promotion") {
      var promotion = element.closest("[data-eoss-promotion]");
      return {
        promotion_id: promotion ? promotion.dataset.eossPromotionId : campaignId,
        promotion_name: promotion ? promotion.dataset.eossPromotionName : "End of season training collar sale",
        creative_slot: promotion ? promotion.dataset.eossPlacement : "homepage_hero",
        location: location,
        destination: destination,
      };
    }

    if (eventName === "select_item") {
      return {
        item_list_id: "end_of_season_training_collars_2026",
        item_list_name: "End of season training collar sale",
        location: location,
        destination: destination,
        items: [
          {
            item_id: element.dataset.eossProduct || undefined,
            item_name: element.dataset.eossProductName || undefined,
          },
        ],
      };
    }

    return {
      promotion_id: campaignId,
      location: location,
      item_id: element.dataset.eossProduct || undefined,
      item_name: element.dataset.eossProductName || undefined,
      quantity: element.dataset.eossQuantity ? Number(element.dataset.eossQuantity) : undefined,
      offer: element.dataset.eossOffer || undefined,
      destination: destination,
    };
  }

  function initStickyHeaderOffset(root) {
    var page = root.matches && root.matches(".eoss-page") ? root : root.querySelector(".eoss-page");
    if (!page || page.dataset.eossStickyOffsetReady === "true") return;

    var header = document.querySelector(".section-header");
    if (!header) return;
    page.dataset.eossStickyOffsetReady = "true";

    function syncOffset() {
      var isVisible =
        header.classList.contains("shopify-section-header-sticky") &&
        !header.classList.contains("shopify-section-header-hidden");
      var offset = isVisible ? Math.ceil(header.getBoundingClientRect().height) : 0;
      page.style.setProperty("--eoss-sticky-header-offset", offset + "px");
    }

    var classObserver = new MutationObserver(syncOffset);
    classObserver.observe(header, {
      attributes: true,
      attributeFilter: ["class"],
    });

    if ("ResizeObserver" in window) {
      var resizeObserver = new ResizeObserver(syncOffset);
      resizeObserver.observe(header);
    }

    window.addEventListener("resize", syncOffset, { passive: true });
    syncOffset();
  }

  function init(root) {
    initPromotionViews(root);
    initStickyHeaderOffset(root);

    if (document.documentElement.dataset.eossTrackingReady === "true") return;
    document.documentElement.dataset.eossTrackingReady = "true";

    document.addEventListener("click", function (event) {
      var target = event.target.closest("[data-eoss-track]");
      if (!target) return;
      var eventName = target.dataset.eossTrack;
      track(eventName, clickDetails(target, eventName));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
